import * as React from "react";
const SvgIcLightningFilled = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M4 16L10 16V24H12L20 8H14L14 0H12L4 16Z" fill="currentColor" /></svg>;
export default SvgIcLightningFilled;